import apiClient from './client';

export async function createUser(username, password) {
  const res = await apiClient.post('/api/v1/users', { username, password });
  return res.data;
}

export async function verifyEmail(email, token) {
  const res = await apiClient.post('/api/v1/users/verify-email', { email, token });
  return res.data;
}

export async function resendVerification(username) {
  const res = await apiClient.post('/api/v1/users/verification/resend', { username });
  return res.data;
}

export async function resetPassword(username, newPassword) {
  const res = await apiClient.post('/api/v1/users/password-reset', { username, newPassword });
  return res.data;
}